// 待补充新的事件
// 事件名称 -> 事件id
export enum UserEvents {
  // 显示历史消息提示
  GetHistoryPrompt = 1,
}

// 事件状态
export enum UserEventStatus {
  // 不存在该事件
  NonExist,
  // 事件已存在
  Exist,
  // 默认状态，前端自定义，可修改，不要直接使用值
  Default = 100,
}

export enum LOYALTY_TIER {
  TierPremiumOutGrayscale = 1,
  TierClassic = 10,
  TierSilver = 20,
  TierGold = 30,
  TierPremium = 40
}
